import { render, staticRenderFns } from "./BDB.vue?vue&type=template&id=0bd9361c&scoped=true&"
import script from "./BDB.vue?vue&type=script&lang=js&"
export * from "./BDB.vue?vue&type=script&lang=js&"
import style0 from "./BDB.vue?vue&type=style&index=0&id=0bd9361c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd9361c",
  null
  
)

export default component.exports